// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"166":"patient-profile","594":"about","609":"faq","974":"patient-virtual-visit"}[chunkId] || chunkId) + "." + {"166":"5313d8ee","442":"45e07e0b","594":"78244257","609":"32e400ee","936":"a575d24c","974":"e4025115"}[chunkId] + ".chunk.js";
};